import { signOut as amplifySignOut } from "aws-amplify/auth";
import useAnalytics from "@/services/analytics/useAnalytics.ts";

export function useSignOut() {
    const analytics = useAnalytics();
    return {
        signOut: async () => {
            // Amplify revokes the refresh token as part of signing out, and
            // reads it from storage to do so. Clearing storage first left it
            // nothing to revoke, so a copied refresh token kept working after
            // sign-out for the rest of its lifetime.
            try {
                await amplifySignOut();
            } catch (err) {
                console.error("Sign out failed:", err);
            }

            // Somehow signout doesn't clear local storage in production
            clearCognitoLocalStorage();

            // Reset analytics
            analytics.reset();

            window.location.href = "/login";
        },
    };
}

/**
 * Every key Amplify keeps for the Cognito session. Exported for the one
 * place that ends a session without leaving for /login: a session start the
 * Api answered with "use your single sign-on" (CognitoAuthenticator), which
 * signs out and redirects to the identity provider instead.
 */
export function clearCognitoLocalStorage() {
    // Get all keys in localStorage
    const keys = Object.keys(localStorage);

    // Filter for keys that start with the Cognito prefix
    const cognitoKeys = keys.filter((key) =>
        key.startsWith("CognitoIdentityServiceProvider"),
    );

    // Remove each key
    cognitoKeys.forEach((key) => {
        localStorage.removeItem(key);
    });
}
